// JavaScript Document

// eslint-disable-next-line no-unused-vars
export default class NamedPair {
  name = null;
  value = null;

  constructor(name, value) {
    this.name = name;
    this.value = value;
  }
}

export { NamedPair };
